<template>
  <footer class="bg-dark text-white text-center py-3">
    <p>&copy; 2025 | Wrona School - All Rights Reserved</p>
    <div class="social-links">
      <a href="https://www.instagram.com/wrona_school?igsh=MW8wcGZ5dTd1N3c4eg==" target="_blank"><i class="fab fa-instagram"></i></a>
      <a href="https://www.tiktok.com/@wrona.school?_t=ZM-8u9i2t6WlPy" target="_blank"><i class="fab fa-tiktok"></i></a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
};
</script>

<style scoped>
.site-footer {
  margin-top: auto;
  background: #343a40;
  width: 100%;
}

.social-links a {
  margin: 0 10px; /* Add horizontal margin to space out the icons */
}
</style>